<template>
  <div class="VIDS">
    <vlt-callout
      style="background-color: khaki"
      v-if="alerts"
      :dismissable="true"
      type="warning"
      @dismissed="gone"
    >
      <h5>
        <span style="margin-right: 30px" v-html="alertMsg"></span>
        <vlt-button
          v-if="msgCount"
          label="View Messages"
          quaternary
          app
          @click="view"
        />
        <vlt-button
          v-if="false"
          small
          label="Dismiss Alert"
          secondary
          app
          @click="gone"
        />
      </h5>
    </vlt-callout>
    <div>
      <sideMenu
        v-if="!isLoading"
        :nexmo="nexmo"
        :myDemo="start"
        @alert="alert"
        :doMessages="messages"
      />
    </div>
  </div>
</template>

<script>
import {
  VltIcon,
  VltButton,
  VltCard,
  VltTab,
  VltGrid,
  VltCol,
  VltCallout,
} from "@vonagevolta/vue";
if (1 || this.$branded) {
  //import VoltaIcons from "@vonagevolta/test/dist/symbol/volta-icons.svg";

  require("@vonagevolta/volta2/dist/symbol/volta-icons.svg");
} else {
  //import VoltaIcons from "@vonagevolta/core/dist/symbol/volta-icons.svg";

  require("@vonagevolta/volta2/dist/symbol/volta-icons.svg");
}
import nidsDemos from "./nidsDemos.vue";
import nidsHistory from "./nidsHistory.vue";
import userAdmin from "./userAdmin";
import myAccount from "./myAccount";
import sideMenu from "./sideMenu";

import login from "./login";

import { $HTTP } from "../services/nidsInternal.js";
import { globalStore } from "@/main.js";
export default {
  name: "VIDS",
  data() {
    return {
      msg: "Vonage Interactive Demo Suite",
      tab: 1,
      nexmo: {},
      isLoading: true,
      start: 0,
      alerts: false,
      alertMsg: "",
      messages: false,
      msgCount: 0,
    };
  },
  components: {
    "vlt-icon": VltIcon,
    "vlt-button": VltButton,
    "vlt-callout": VltCallout,
    nidsDemos,
    nidsHistory,
    userAdmin,
    myAccount,
    login,
    sideMenu,
  },
  methods: {
    gone() {
      console.log("Banner dismissed.");
      this.alerts = false;
      this.dismiss();
    },
    view() {
      console.log("View dismissed.");
      this.alerts = false;
      this.messages = true;
    },
    alert(val, msg) {
      console.log("Got incoming alert! ", val);
      this.alertMsg = val;
      this.msgCount = msg;
      if (val) {
        this.alerts = true;
      } else {
        this.alerts = false;
      }
    },
    dismiss() {
      $HTTP.post("clearAlert", {});
    },
    async fetch() {
      this.isLoading = true;
      if (this.$route.query && this.$route.query.id) {
        console.log("VIDS Writing redirection: " + this.$route.query.id);
        localStorage.redirect = this.$route.query.id;
      }
      const { data } = await $HTTP.get("nexmo").catch((error) => {
        console.warn("Invalid token, probably");
        this.logout();
        return;
      });
      let tmp = data.language;
      console.log("Language: "+tmp)
      console.log("User Info: ",data)
      if (!data) {
        if (this.$route.query && this.$route.query.id) {
          console.log(
            "VIDS error, Writing redirection: " + this.$route.query.id
          );
          localStorage.redirect = this.$route.query.id;
        }
      } else {
        delete localStorage.redirect;
      }

      this.isLoading = false;
      this.nexmo = data;
      if (this.nexmo.role == "admin" || this.nexmo.role == "translator") {
        console.log("Setting disp gather");
        globalStore.$gather = true;
      }
      if (data.info) {
        console.log("data.info=" + data.info);
        let info = JSON.parse(data.info);
        this.nexmo.info = info;
      }
      console.log(this.nexmo);
    },
    async logout() {
      await $HTTP.get("logout").catch((err) => console.log(err));
      delete localStorage.token;
      this.$router.push("/?redirect=" + this.$route.path);
    },
  },
  created() {
    if (this.$route.query.id) {
      this.start = parseInt(this.$route.query.id);
    }
    this.fetch();
    console.log("Starting VIDS in mode: " + process.env.NODE_ENV);
  },
  updated() {
    if (!localStorage.token && this.$route.path !== "/") {
      this.$router.push("/?redirect=" + this.$route.path);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.VIDS {
  text-align: initial;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>
